import { InputNumber, type GetRef, type InputNumberProps } from 'antd';
import { type Ref } from 'react';

export type InputNumberRef = GetRef<typeof InputNumber>;

function AiInputNumber(
  props: InputNumberProps<number> & { ref?: Ref<InputNumberRef> },
) {
  return (
    <InputNumber
      min={Number.MIN_SAFE_INTEGER}
      max={Number.MAX_SAFE_INTEGER}
      placeholder="请输入"
      {...props}
    ></InputNumber>
  );
}

type AiInputNumberProps = InputNumberProps<number>;

export {
  AiInputNumber as InputNumber,
  type AiInputNumberProps as InputNumberProps,
};
